import { api } from './api';
import { Position, CreatePositionRequest, UpdatePositionRequest } from '../types/position.type';
import { Worker } from '../types/worker.type';

export const positionApi = {
  getPositions: async (): Promise<Position[]> => {
    const response = await api.get('/position');
    return response.data;
  },

  createPosition: async (position: CreatePositionRequest): Promise<Position> => {
    const response = await api.post('/position', position);
    return response.data;
  },

  updatePosition: async (id: string, position: UpdatePositionRequest): Promise<Position> => {
    const response = await api.put(`/position/${id}`, position);
    return response.data;
  },

  deletePosition: async (id: string): Promise<void> => {
    await api.delete(`/position/${id}`);
  },

  getWorkersForPosition: async (): Promise<Worker[]> => {
    const response = await api.get('/position/workers/list');
    return response.data;
  },

  updateSortOrder: async (positions: { id: string; sortOrder: number }[]): Promise<void> => {
    await api.put('/position/sort/order', { positions });
  },

  removeWorkerFromPosition: async (positionId: string, workerId: string): Promise<void> => {
    await api.delete(`/position/${positionId}/worker/${workerId}`);
  },
}; 